<template>
  <Modal
    id="ServiceProviderEdit"
    width="80%"
    :visible="visible"
    @cancel="visible = !visible"
    @ok="submit"
    :title="title"
    :zIndex="9999999900"
  >
    <Row align="middle" justify="center">
      <Col span="18" class="content">
        <Row>
          <Col span="24">
            <Form
              ref="serviceProviderForm"
              :model="form"
              layout="vertical"
              :rules="validateRules"
            >
              <Row justify="space-around">
                  <Col span="10">
                    <FormItem :label="$t('serviceProvider.field.company_name')" name="companyName">
                      <Input :placeholder="$t('serviceProvider.validate.required.company_name')"
                             v-model:value="form.companyName">
                      </Input>
                  </FormItem>
                  </Col>
                  <Col span="10">
                    <FormItem :label="$t('serviceProvider.field.company_code')" name="companyCode">
                      <Input :placeholder="$t('serviceProvider.validate.required.company_code')"
                             v-model:value="form.companyCode">
                      </Input>
                  </FormItem>
                  </Col>
                  <Col span="10">
                    <FormItem :label="$t('serviceProvider.field.status')" name="status">
                      <Select
                              v-model:value="form.status"
                              :placeholder="$t('serviceProvider.validate.required.status')"
                              :options="selectList.statusList"
                              :dropdownStyle="{ zIndex: 9999999950 }"
                      >
                      </Select>
                  </FormItem>
                  </Col>
                  <Col span="10">
                    <FormItem :label="$t('serviceProvider.field.short_name')" name="shortName">
                                            <Input :placeholder="$t('serviceProvider.validate.required.short_name')"
                                                   v-model:value="form.shortName">
                                            </Input>
                  </FormItem>
                  </Col>
                <!--�ж��Ƿ����ӱ����������ֱ�Ӽ����ӱ������߼�-->
              </Row>
            </Form>
          </Col>
        </Row>
      </Col>
    </Row>
  </Modal>
</template>

<script>
import {
  Modal,
  Row,
  Col,
  Form,
  Input,
  InputNumber,
  Image,
  Radio,
  Steps,
  Step,
  Button,
  message,
  Select,
  DatePicker,
  InputGroup,
  Upload,
  Descriptions,
  DescriptionsItem,
} from "ant-design-vue";
import {
  UploadOutlined,
  UserOutlined,
  SolutionOutlined,
  FileImageOutlined,
  CheckOutlined,
  PlusOutlined,
} from "@ant-design/icons-vue";
import { ServiceProviderAdd } from "@/api/ServiceProviderAdd";
import { ServiceProviderEdit } from "@/api/ServiceProviderEdit";


export default {
  name: "ServiceProviderEdit",
  components: {
    Modal,
    Row,
    Col,
    UserOutlined,
    SolutionOutlined,
    FileImageOutlined,
    CheckOutlined,
    UploadOutlined,
    PlusOutlined,
    Form: Form,
    FormItem: Form.Item,
    Input: Input,
    InputPassword: Input.Password,
    Textarea:Input.TextArea,
    InputGroup,
    InputNumber,
    Image,
    RadioGroup: Radio.Group,
    RadioButton: Radio.Button,
    Steps,
    Step,
    Button,
    message,
    Select,
    SelectOption: Select.Option,
    DatePicker,
    Upload,
    Descriptions,
    DescriptionsItem,
  },
  data() {
    return {
      visible: false,
      actionType: "",
      form: {
        idSerPro : "",
        companyName : "",
        companyCode : "",
        createDate : "",
        status : "",
        shortName : "",
      },
      fileList: {
      },
      selectList: {
        statusList: [{value: 0,label: 'Off'},{value:1,label: 'On'}],
      },
      validateRules: {
        idSerPro: [
          {
            required: true,
            message: this.$t("serviceProvider.validate.required.id_ser_pro"),
            trigger: "change",
            type: "number",
          },
        ],
        companyName: [
          {
            required: true,
            message: this.$t("serviceProvider.validate.required.company_name"),
            trigger: "change",
          },
        ],
        companyCode: [
          {
            required: true,
            message: this.$t("serviceProvider.validate.required.company_code"),
            trigger: "change",
          },
        ],
        createDate: [
          {
            required: true,
            message: this.$t("serviceProvider.validate.required.create_date"),
            trigger: "change",
          },
        ],
        status: [
          {
            required: true,
            message: this.$t("serviceProvider.validate.required.status"),
            trigger: "change",
            type: "number",
          },
        ],
        shortName: [
          {
            required: true,
            message: this.$t("serviceProvider.validate.required.short_name"),
            trigger: "change",
          },
        ],
      },
    };
  },
  computed: {
    title: function () {
      let name = "";
      switch (this.actionType) {
        case "add":
          name = this.$t("public.name.add");
          break;
        case "edit":
          name = this.$t("public.name.edit");
          break;
      }
      return name;
    },
  },
  methods: {
    addShow() {
      this.actionType = "add";
      this._resetData();
      this.visible = true;
    },
    async editShow(obj) {
      this._resetData();
      this.actionType = "edit";
      this.form = JSON.parse(JSON.stringify(obj));
      this.visible = true;
    },
    submit() {
      this.$refs["serviceProviderForm"]
        .validate()
        .then(() => {
          let api;
          switch (this.actionType) {
            case "add":
              console.log("add");
              api = new ServiceProviderAdd();
              break;
            case "edit":
              console.log("edit");
              api = new ServiceProviderEdit();
              break;
            default:
              return false;
          }
          api.post(this.form).then((response, any) => {
            if (0 == parseInt(response.data.code)) {
              message.success(response.data.msg);
              this.$emit("updateList");
              this.visible = false;
            } else {
              message.error(response.data.msg);
            }
          });
        })
        .catch(() => {
        });
    },
    // reset data
    _resetData() {
      this.form = {
        idSerPro : "",
        companyName : "",
        companyCode : "",
        createDate : "",
        status : "",
        shortName : "",
      };
    },
  },
};
</script>

<style lang="less">
</style>